export default __webpack_public_path__ + "static/weare-5-70e6d917e9faa3a2afec792a8d801993.png";